import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bf-auth" }
const _hoisted_2 = { class: "bf-auth__form-wrap" }
const _hoisted_3 = { class: "bf-auth__card" }
const _hoisted_4 = { class: "bf-field" }
const _hoisted_5 = { class: "bf-auth__signup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"bf-auth__brand\"><div class=\"bf-auth__brand-inner\"><img class=\"bf-auth__brand-logo\" src=\"/img/brand/bindfy_logo_new_white.png\" alt=\"Bindfy\"><h2>Recupere seu acesso.</h2><p> Enviaremos um link para o seu e-mail com as instruções para redefinir sua senha com segurança. </p></div><div class=\"bf-auth__blob bf-auth__blob--1\"></div><div class=\"bf-auth__blob bf-auth__blob--2\"></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("img", {
          class: "bf-auth__logo-mobile",
          src: "/img/brand/bindfy_logo_new_purple.png",
          alt: "Bindfy"
        }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "bf-auth__title" }, "Esqueci minha senha", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "bf-auth__desc" }, " Insira seu e-mail e enviaremos as instruções para recuperar sua senha ", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("label", null, "E-mail", -1)),
            _createVNode(_component_TextInput, {
              label: 'Digite o seu e-mail',
              type: 'email',
              modelValue: _ctx.forgotPasswordForm.login,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.forgotPasswordForm.login) = $event)),
              "error-messages": 
                _ctx.v$.login.$errors ? _ctx.v$.login.$errors[0]?.$message : undefined
              
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _createVNode(_component_PrimaryButton, {
            "is-loading": _ctx.isLoading,
            label: "Enviar e-mail de recuperação"
          }, null, 8, ["is-loading"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/autenticar/acessar",
              class: "bf-link"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" ← Voltar para login ", -1)
              ]))]),
              _: 1
            })
          ])
        ], 32)
      ])
    ])
  ]))
}